import classNames from "classnames";
import { graphql } from "gatsby";
import React from "react";
import Button from "../atoms/button";
import Image from "../atoms/image";

const BannerPromo = ({ data, origin }) => {
  return data.origin === "pdp" || data.origin === "blog" || origin === "pdp" ? (
    <div
      className={classNames(
        "banner-promo-pdp",
        data.positionImage?.[0] === "right" && "banner-promo-pdp--right",
        (data.positionImage?.[0] === "left" || data.positionImage?.[0] === null) &&
          "banner-promo-pdp--left"
      )}
    >
      {data.hooverStImage?.image && (
        <div
          className={classNames(
            "banner-promo-pdp__image",
            (data.positionImage?.[0] === "full" || data.positionImage?.[0] === "background") &&
              "banner-promo-pdp__image--full"
          )}
        >
          <Image
            image={data.hooverStImage?.image}
            objectPosition={`${data.hooverStImage.focuslr?.[0] || "center"} ${
              data.hooverStImage.focustb?.[0] || "center"
            }`}
            alt={data.image?.value?.description || ""}
          />
        </div>
      )}
      {data.positionImage?.[0] !== "full" && (
        <div
          className={classNames(
            "banner-promo-pdp__text",
            data.positionImage?.[0] === "background" && "banner-promo-pdp__text--background"
          )}
        >
          <p className="banner-promo-pdp__text-title">{data.title}</p>
          {data.subtitle && <p className="banner-promo-pdp__text-subtitle">{data.subtitle}</p>}
          {data.abstract && (
            <p
              className="banner-promo-pdp__text-content"
              dangerouslySetInnerHTML={{
                __html: data.abstract,
              }}
            ></p>
          )}
          {data.cta && (
            <Button
              className={classNames(
                "banner-promo-pdp__text-cta",
                data.cta.color?.[0] === "white" && "alternate"
              )}
              data={data.cta}
              iconName="symbols-chevron-right"
            ></Button>
          )}
        </div>
      )}
    </div>
  ) : data.origin === "plp" || origin === "plp" ? (
    <>
      {data.hooverStImage?.image && (
        <div
          className={classNames(
            "banner-promo-plp__image",
            (data.positionImage?.[0] === "full" || data.positionImage?.[0] === "background") &&
              "banner-promo-plp__image--full"
          )}
        >
          <Image
            image={data.hooverStImage?.image}
            objectPosition={`${data.hooverStImage.focuslr?.[0] || "center"} ${
              data.hooverStImage.focustb?.[0] || "center"
            }`}
            alt={data.image?.value?.description || ""}
          />
        </div>
      )}
      {data.positionImage?.[0] !== "full" && (
        <div
          className={classNames(
            "banner-promo-plp__text",
            data.positionImage?.[0] === "background" && "banner-promo-plp__text--full"
          )}
        >
          <p className="banner-promo-plp__text-title">{data.title}</p>
          {data.subtitle && <p className="banner-promo-plp__text-subtitle">{data.subtitle}</p>}
          {data.abstract && (
            <p
              className="banner-promo-plp__text-content"
              dangerouslySetInnerHTML={{
                __html: data.abstract,
              }}
            ></p>
          )}
          {data.cta && (
            <Button data={data.cta} rel="noopener noreferrer" className="primary blue" />
          )}
        </div>
      )}
    </>
  ) : null;
};

export default BannerPromo;
export const fragment = graphql`
  fragment BannerPromoFragment on LiferayBannerPromo {
    id
    title
    subtitle
    abstract
    positionImage
    hooverStImage {
      focuslr
      focustb
      image {
        node {
          publicURL
          gatsbyImageData(layout: FULL_WIDTH)
        }
        value {
          description
        }
      }
    }
    cta {
      ...ButtonFragment
    }
  }
`;
